module.exports = __webpack_public_path__ + "img/tasks_active.03734a29.svg";